import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { getOrgKeyValue, getPriceDetails, getPriceList, logItemPriceListHistory } from '../../../services/index';
import AddIcon from '@mui/icons-material/Add';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { searchForMatch } from '../../utils/textUtils';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';
import { useRef } from 'react';

const ViewPriceList = () => {
    let { id } = useParams();
    const [logData, setLogData] = useState({});
    const [priceDetails1, setPriceDetails1] = useState([]);
    const [rows, setRows] = useState([]);
    const [priceListDetails, setPriceListDetails] = useState(null);
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [orgOptions, setOrgOptions] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState({
        label: "",
        value: ""
    });

    const componentRef = useRef();

    useEffect(() => {
        logItemPriceListHistory(id).then((res) => {
            if (res.errorCode === 0) {
                const d = res.responsePacket;
                setLogData(d);
            } else {
                toast(res.message);
            }
        });

    }, [id]);

    const getPriceDetails12 = (id) => {
        getPriceDetails(id).then((res) => {
            if (res.errorCode === 0) {
                setPriceDetails1(res.responsePacket);
            } else {
                toast.error(res.message);
            }
        });
    };

    const getAllPriceRecords = () => {
        let price_data = {
            page: 0,
            size: 0 - 1,
            search: filterText,
            uuid: selectedOrg.value,
        };
        getPriceList(price_data).then((res) => {
            if (res.errorCode === 0) {
                if (index === 0) {
                    const d = res.responsePacket.data;
                    d.reverse();
                    setRows(d);
                    setData(d);
                } else {
                    const setPriceListClone = [...rows, ...res.responsePacket.data];
                    setRows(setPriceListClone);
                    setData(setPriceListClone);
                }
                setIndex(index + 1);
                setPriceListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                })
            } else {
                toast(res.message);
            }
        });
    };

    const getOrgDetail = () => {
        getOrgKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setSelectedOrg(options[0]);
                setOrgOptions(options);
            } else {
                toast(res.message);
            }
        });
    }

    useEffect(() => {
        getPriceDetails12(id);

    }, [id]);

    useEffect(() => {
        if (selectedOrg?.value) {
            getAllPriceRecords();
        }
    }, [selectedOrg])

    useEffect(() => {
        getOrgDetail();
    }, [])


    useEffect(() => {
        if (selectedOrg?.value) {
            getAllPriceRecords();
        }
    }, [selectedOrg, filterText])

    const filterOptions = [
        { value: 'isVolumePrice', label: 'isVolumePrice' },
        { value: 'isUnitPrice', label: 'isUnitPrice' },
        { value: 'isMarkUp', label: 'isMarkUp' },
        { value: 'isMarkDown', label: 'isMarkDown' },
    ];

    const [data, setData] = useState([]);
    const [search, setSearch] = useState([]);


    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const handleFilter = (e) => {
        setSelectedOrg(e);
        setIndex(0);
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <>
            <div className='list-column column d-print-none' style={{ width: '300px' }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <Link to="/pricelist/new" className="newListBtn">
                            <AddIcon />
                            New
                        </Link>
                        <div className="listFilter">
                            <Select value={selectedOrg} options={orgOptions} onChange={(e) => handleFilter(e)} />
                        </div>
                        <div className="input-group paginationSearchInput listSearch">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon1">
                                    <SearchRoundedIcon />
                                </span>
                            </div>
                            <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={handleSearch} />
                        </div>
                    </div>
                </div>
                <div className='scroll-y fill body scrollbox list-body'>
                    <div className='table-responsive overflow-initial'>
                        <table id='ember7912' className='table zi-table table-hover ember-view header-fixed'>
                            {data && (data.length > 0 ?
                                (<tbody>
                                    {data.map((row, i) => (
                                        <tr key={i} className={`listTr ${id === row.recordId ? 'activeRecord' : ''}`} onClick={() => getPriceDetails12(row.recordId)}>
                                            <td>
                                                <Link to={`/pricelists/${row.recordId}`} className={`${id === row.recordId ? 'text-primary' : 'text-grey'}`}>
                                                    <span className='titleTr'>{row.title}</span>
                                                    <span className='d-flex justify-content-between'>
                                                        <span>Type: {row?.itemPriceListTypeEnum}</span>
                                                        <span>
                                                            {row?.isMarkUp ? 'markup' : <></>}
                                                            {row?.isMarkDown ? 'MarkDown' : <></>}
                                                            {row?.isUnitPrice ? 'UnitPrice' : <></>}
                                                            {row?.isVolumePrice ? 'VolumePrice' : <></>}
                                                        </span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        priceListDetails &&
                                        priceListDetails.recordsTotal >
                                        data.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllPriceRecords}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )}
                                </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                            )}
                        </table>
                    </div>
                </div>
            </div>
            <div className='column content-column ' style={{ left: '301px' }}>
                <div className='header no-border d-flex align-items-center p-4 ml-auto'>
                    <div className='btn-toolbar d-flex justify-content-end align-items-center ml-auto'>
                        <div className='btn-toolbar'>
                            <div className='btn-group'>
                                <Link to={`/pricelists/${priceDetails1.recordId}/edit`} state={{ newEdit: "true" }}>
                                    <button id='ember7700' className='tooltip-container ember-view btn btn-primary mr-0' type='button'>
                                        <ContentCopyIcon />
                                    </button>
                                </Link>
                            </div>
                            <div className='btn-group'>
                                <Link to={`/pricelists/${priceDetails1.recordId}/edit`}>
                                    <button id='ember7700' className='tooltip-container ember-view btn btn-primary mr-0' type='button'>
                                        <EditIcon />
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <Tabs className='upperTabs'>
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                    </TabList>

                    <TabPanel>
                        <div ref={componentRef} className='ember-view scroll-y noscroll-x fill body scrollbox py-3'>
                            <button className="tooltip-container ember-view btn btn-primary print-btn" onClick={handlePrint}>
                                <LocalPrintshopOutlinedIcon />
                            </button>
                            <div id='scroll'>
                                {/* <div className='font-large text-uppercase font-xs text-open mb-2'>
                                    {priceDetails1?.isMarkUp ? 'markup' : <></>}
                                    {priceDetails1?.isMarkDown ? 'MarkDown' : <></>}
                                    {priceDetails1?.isUnitPrice ? 'UnitPrice' : <></>}
                                    {priceDetails1?.isVolumePrice ? 'VolumePrice' : <></>}
                                </div> */}
                                <div className='font-large text-uppercase font-xs text-open my-2'>
                                    {priceDetails1.title}
                                    {priceDetails1?.isMarkDown || priceDetails1?.isMarkUp ? (
                                        <div>{priceDetails1.percentage}</div>
                                    ) : (
                                        <></>
                                    )}
                                    <div><small>{priceDetails1.itemPriceListTypeEnum}</small></div>
                                    <div className='text-black'>{priceDetails1.description}</div>
                                </div>
                            </div>

                            {priceDetails1?.isUnitPrice ? (
                                <div className='card p-3'>
                                    {priceDetails1 && priceDetails1?.itemCustomUnitPriceBeanList.length !== 0 && (
                                        <div className='customTable' id='scroll'>
                                            <h3 className='font-size-16 font-weight-bold ml-2 pb-2 text-black'>Item Details</h3>
                                            <table className='customTable borderedTable w-100'>
                                                <thead>
                                                    <tr>
                                                        <td>Sno.</td>
                                                        <td>Item Title</td>
                                                        <td>Unit</td>
                                                        <td> Price</td>
                                                        <td>Custom Price</td>
                                                    </tr>
                                                </thead>
                                                {priceDetails1 && (
                                                    <tbody>
                                                        {priceDetails1?.itemCustomUnitPriceBeanList.filter((e) => e.active).map((item, i) => (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                <td>{item.itemTitle}</td>
                                                                <td>{item.unitTitle}</td>
                                                                <td>{item.price}</td>
                                                                <td>{item.customPrice}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <></>
                            )}
                            {priceDetails1?.isVolumePrice ? (
                                <div>
                                    {priceDetails1 && priceDetails1?.itemCustomVolumePriceBeansList.length !== 0 && (
                                        <div className='customTable' id='scroll'>
                                            <h3 className='font-size-16 font-weight-bold ml-2 pb-2'>Item Details</h3>
                                            <table className='customTable borderedTable w-100'>
                                                <thead>
                                                    <tr>
                                                        <td>Item Title</td>
                                                        <td>Unit</td>
                                                        <td> Price</td>
                                                        <td>Custom Price</td>
                                                        <td>Start Quantity</td>
                                                        <td>End Quantity</td>
                                                    </tr>
                                                </thead>
                                                {priceDetails1 && (
                                                    <tbody>
                                                        {priceDetails1?.itemCustomVolumePriceBeansList.map((item, i) => (
                                                            <tr key={i}>
                                                                <td>{item.itemTitle}</td>
                                                                <td>{item.unitTitle}</td>
                                                                <td>{item.price}</td>
                                                                <td>{item.customPrice}</td>
                                                                <td>{item.startQuantity}</td>
                                                                <td>{item.endQuantity}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </TabPanel>

                    <TabPanel>
                        <div className='ember-view scroll-y noscroll-x fill body scrollbox py-3'>
                            <table>
                                {logData.length === 0 ? (
                                    'No Changes Found'
                                ) : (
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Changes</th>
                                        </tr>
                                    </thead>
                                )}
                                {logData.length >= 1 && (
                                    <tbody>
                                        {logData?.map((history, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td style={{ verticalAlign: 'top', width: '80px' }}>
                                                        {history?.transactionDate?.substring(0, 10)}
                                                        :&nbsp;&nbsp;
                                                        <br />
                                                        Time:
                                                        {history?.transactionDate?.split('T')[1]?.substring(0, 5)}
                                                    </td>
                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                        {/* {history?.message.split('\n').map((b, j) => (
                                                            <div key={j}>
                                                                {b.includes('\t') ? (
                                                                    <div style={{ marginLeft: '20px' }}>{b}</div>
                                                                ) : b.includes('\t\t') ? (
                                                                    <div style={{ marginLeft: '40px' }}>{b}</div>
                                                                ) : (
                                                                    b
                                                                )}
                                                            </div>
                                                        ))} */}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
            <Toaster />
        </>
    );
};

export default ViewPriceList;
